import React from 'react'
import {motion} from "framer-motion"
const Contact = () => {
  return (
    <div name="Contact" className=' w-full  text-white'>
        <div className='flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full'>
        <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                >

            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-400 '>Contact Me</p>
            </div>
                </motion.div>

            <div className='flex justify-center items-center mt-6 bg-black/5  rounded-md  p-4'>
                <form method="POST" action="https://getform.io/f/nbdomlza" className='flex flex-col w-full md:w-1/2 gap-8'>

                   <input required type="text" name='name' placeholder='Enter your name'
                    className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none' />

                    <input required type="text" name='email' placeholder='Enter your email'
                    className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none' />

                    <textarea required name="message" rows="10"
                    placeholder='Enter your message' className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none resize-none'></textarea>

                    <button className='text-white bg-gradient-to-b font-bold from-cyan-500 to-blue-500 px-6 py-2 mb-8 mx-auto fllex items-center rounded-md hover:scale-110 duration-150'>Let's Talk</button>
                </form>
            </div>
        </div>


    </div>
  )
}

export default Contact;
